import { call, put, takeLatest, takeEvery, fork, all, delay } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import { parseListRequestParams } from '../utils/commonUtils';
import i18n from '../constants/initLng';
import { UserService } from './../services';
import { PATHS, CONFIG_LOCAL_STORAGE } from './../constants/Define';
import { LocalStorage } from './../utils';
import User from '../models/User';
import * as UserActions from '../actions/userAction';
import history from '../helpers/history';

function* getListUser() {
    yield takeLatest(Types.USER_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(action.filters || {});
        const result = yield call(UserService.getUsers, params);
        yield put(UserActions.dataUserSuccess(result));
    }, errorHandleUser(Types.TOUR_GET_LIST_FAIL)))
}

function* getUserDetail() {
    yield takeLatest(Types.USER_GET_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(UserService.getUserDetail, action.params.id);
        yield put(UserActions.getUpdateUserSuccess(result));
    }, errorHandleUser(Types.USER_FAIL)))
}

function* createUser() {
    yield takeLatest(Types.USER_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const data = action.params.data;
        const password = action.params.password;
        const user = new User(data);
        yield call(UserService.createUser, user, password);
        // Clear password from memory after use
        if (action.params) {
            action.params.password = undefined;
        }
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), `${user.firstname || ''} ${user.lastname || ''}`);
        yield put({ type: Types.USER_LIST_ACTION, filters: action.params.filters });
        history.push(PATHS.USER.LIST.path);
        history.go();
    }, errorHandleUser(Types.USER_FAIL)))
}

function* updateUser() {
    yield takeLatest(Types.USER_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const user = new User(action.params.data);
        yield call(UserService.updateUser, user);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), `${user.firstname || ''} ${user.lastname || ''}`);
        yield put({ type: Types.USER_LIST_ACTION, filters: action.params.PageIndex })
    }, errorHandleUser(Types.USER_FAIL)))
}

function* updateForceMfa() {
    yield takeEvery(Types.USER_FORCE_MFA_UPDATE_ACTION, function* (action) {
        const { id, forceMfa } = action.params;
        try {
            yield call(UserService.updateForceMfa, id, forceMfa);
            yield put(UserActions.updateForceMfaSuccess({ id, forceMfa }));
            Func.sagaSuccessMessage(action, i18n.t('notification.updateSuccess'));
            if (action.params.filters) {
                yield put({ type: Types.USER_LIST_ACTION, filters: action.params.filters });
            }
        } catch (e) {
            yield put(UserActions.updateForceMfaFail({ id }));
            const handleError = Func.sagaErrorHandler(null, 'user');
            yield* handleError(e, action);
        }
    });
}

function* deleteUser() {
    yield takeLatest(Types.USER_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(UserService.deleteUser, action.params.id);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.203'));
        yield put({ type: Types.USER_LIST_ACTION, filters: action.params.PageIndex })
    }, errorHandleUser(Types.USER_FAIL)))
}

function* getUserRole() {
    yield takeLatest(Types.USER_GET_ROLE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(UserService.getUserRole);
        yield put(UserActions.getRoleUserSuccess(result || []));
    }, errorHandleUser(Types.USER_FAIL)))
}

function* getCSUsers() {
    yield takeLatest(Types.USER_GET_CS_USER_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(UserService.getCSUsers);
        yield put(UserActions.getCSUserSuccess(result || []));
    }, errorHandleUser(Types.USER_FAIL)))
}

function* getCustomerUsers() {
    yield takeLatest(Types.USER_GET_CUSTOMER_USER_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(UserService.getCustomerUser);
        yield put(UserActions.getCustomerUserSuccess(result || []));
    }, errorHandleUser(Types.USER_FAIL)))
}

function* changeUserPassword() {
    yield takeLatest(Types.USER_CHANGE_PASSWORD_ACTION, Func.sagaWrapper(function* (action) {
        const data = action.params;
        const oldPassword = data.oldPassword;
        const newPassword = data.newPassword;
        yield call(UserService.changePassword, oldPassword, newPassword);
        // Clear passwords from memory after use
        if (action.params) {
            action.params.oldPassword = undefined;
            action.params.newPassword = undefined;
        }
        Func.sagaSuccessMessage(action, i18n.t('notification.changePasswordSuccess'))
        LocalStorage.remove(CONFIG_LOCAL_STORAGE.ACCESS_TOKEN);
        LocalStorage.remove(CONFIG_LOCAL_STORAGE.REFRESH_TOKEN);
        LocalStorage.remove(CONFIG_LOCAL_STORAGE.EXPIRES);
        yield delay(1000);
        yield put({ type: Types.USER_CHANGE_PASSWORD_SUCCESS });
    }, errorHandleUser(Types.USER_CHANGE_PASSWORD_FAIL)))
}

function errorHandleUser(errorActionType) {
    return Func.sagaErrorHandler(function* (e){
        yield put({ type: errorActionType })
    }, 'user');
}

export function* userSaga() {
    yield all([
        fork(getListUser),
        fork(createUser),
        fork(deleteUser),
        fork(getUserDetail),
        fork(updateUser),
        fork(updateForceMfa),
        fork(getUserRole),
        fork(changeUserPassword),
        fork(getCSUsers),
        fork(getCustomerUsers),
    ])
}
